import { Center, Spinner } from '@chakra-ui/react';

const FullScreenLoader = () => {
    return (
        <Center w="100%" h="100%">
            <Spinner />
        </Center>
    );
};

export default FullScreenLoader;
